






import { FirebaseAuthentication } from '@/Firebase/FirebaseAuthentication';
import { FirebaseEmployeeDataFileService } from '@/Firebase/FirebaseEmployeeDataFileService';
import { FirebaseExportService } from '@/Firebase/FirebaseExportService';
import { FirebaseInviteService } from '@/Firebase/FirebaseInviteService';
import { FirebaseReportFileService } from '@/Firebase/FirebaseReportFileService';
import { FirebaseSurveyTemplateFileService } from '@/Firebase/FirebaseSurveyTemplateFileService';
import { debounce } from 'lodash';
import Vue from 'vue';
import { Component, Provide } from 'vue-property-decorator';
import { auth, holisticFunctions, storage } from './server';

@Component
export default class App extends Vue {
  @Provide() public authenticationService = new FirebaseAuthentication(auth);
  @Provide() public debounce = debounce;
  @Provide()
  public employeeDataFileService = new FirebaseEmployeeDataFileService(storage);
  @Provide()
  public reportFileService = new FirebaseReportFileService(storage);
  @Provide() public exportService = new FirebaseExportService(
    holisticFunctions,
    storage,
  );
  @Provide() public inviteService = new FirebaseInviteService(
    holisticFunctions,
    auth,
  );
  @Provide() public surveyTemplateFileService = new FirebaseSurveyTemplateFileService(
          storage);
}
